module.exports = __webpack_public_path__ + "static/media/bbva.8e782030.svg";